import React, { useEffect, useRef, useState } from 'react';
import { Play, ChevronLeft, ChevronRight } from 'lucide-react';
import { getProducts } from '../services/api';

export default function VideoTestimonials({ onOpen }) {
  const scroller = useRef(null);
  const [items, setItems] = useState([]);

  // Pull all products that have at least one video in their gallery
  // (admin-managed via the product form).
  useEffect(() => {
    getProducts().then(products => {
      const out = [];
      (products || []).forEach(p => {
        (p.gallery || []).forEach(url => {
          if (/\.(mp4|webm|mov)(\?|$)/i.test(url)) {
            out.push({ id: `${p.id}-${url}`, product: p, url });
          }
        });
      });
      setItems(out);
    });
  }, []);

  if (items.length === 0) return null;

  const scroll = (dir) => {
    const el = scroller.current;
    if (!el) return;
    el.scrollBy({ left: dir * el.clientWidth * 0.8, behavior: 'smooth' });
  };

  return (
    <section className="py-14 sm:py-16 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <h2 className="font-serif text-3xl sm:text-4xl lg:text-5xl text-neutral-900 text-center leading-tight">
          Don&#39;t take our words for it.<br className="sm:hidden" /> Take theirs
        </h2>

        <div className="relative mt-8">
          <button onClick={() => scroll(-1)} className="hidden sm:grid absolute left-0 top-1/2 -translate-y-1/2 z-10 w-10 h-10 place-items-center bg-white shadow-md rounded-full hover:bg-neutral-100 transition-colors" aria-label="Prev"><ChevronLeft className="w-5 h-5" /></button>

          <div ref={scroller} className="flex gap-4 overflow-x-auto no-scrollbar snap-x snap-mandatory px-1 sm:px-8">
            {items.map((v) => (
              <button
                key={v.id}
                onClick={() => onOpen && onOpen(v.product)}
                className="snap-center shrink-0 w-[70%] sm:w-[42%] md:w-[30%] lg:w-[22%] relative rounded-xl overflow-hidden bg-neutral-900 aspect-[9/16] cursor-pointer group"
              >
                <video
                  src={v.url}
                  muted
                  loop
                  autoPlay
                  playsInline
                  className="absolute inset-0 w-full h-full object-cover transition-transform duration-500 group-hover:scale-105"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-black/10 to-transparent" />
                <div className="absolute inset-0 grid place-items-center">
                  <div className="w-14 h-14 rounded-full bg-white/95 grid place-items-center shadow-lg group-hover:scale-110 transition-transform">
                    <Play className="w-6 h-6 text-[#1e3a2b] translate-x-0.5" fill="currentColor" />
                  </div>
                </div>
                <div className="absolute bottom-3 left-3 right-3 text-white text-left">
                  <div className="text-sm font-semibold line-clamp-1">{v.product.title.split('|')[0]}</div>
                  <div className="text-xs opacity-80">Tap to view product</div>
                </div>
              </button>
            ))}
          </div>

          <button onClick={() => scroll(1)} className="hidden sm:grid absolute right-0 top-1/2 -translate-y-1/2 z-10 w-10 h-10 place-items-center bg-white shadow-md rounded-full hover:bg-neutral-100 transition-colors" aria-label="Next"><ChevronRight className="w-5 h-5" /></button>
        </div>
      </div>
    </section>
  );
}